import GeoCoordinate from '../types/GeoCoordinate'

/**
 * The default geographic location used for maps and related features.
 * Set to the coordinates of Helsinki, Finland.
 */
export const defaultLocation: GeoCoordinate = {
  lat: 60.170833,
  long: 24.9375
}
